import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/services/property-care/PropertyCareClient.jsx");
